(function () {
    'use strict';

    angular.module("imApp").factory("listDataService", ['$ihttp', function ($ihttp) {
        let service = {
            getListData: function (parms) {
                return $ihttp.post({
                    method: 2719,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2720,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
